import noop from 'lodash/noop';
import { SOFTWARE_PROJECT } from '@atlassian/jira-common-constants/src/project-types';
import { defaultLocale } from '@atlassian/jira-common-constants/src/supported-locales';
import {
	FREE_EDITION,
	populateApplicationEditions,
	STANDARD_EDITION,
} from '@atlassian/jira-shared-types/src/edition.tsx';
import { INITIALIZE_CONTEXT, type InitializeContextAction } from './actions';
import type { ContextState } from './types';

type Action = InitializeContextAction;

export const contextInitialState: ContextState = {
	isAdmin: false,
	baseUrl: '',
	locale: defaultLocale,
	projectId: 0,
	projectType: SOFTWARE_PROJECT,
	onDetailsUpdated: noop,
	simplified: false,
	appEditions: populateApplicationEditions({
		software: STANDARD_EDITION,
		core: STANDARD_EDITION,
		serviceDesk: STANDARD_EDITION,
		productDiscovery: FREE_EDITION,
	}),
};

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (state: ContextState = contextInitialState, action: Action): ContextState => {
	switch (action.type) {
		case INITIALIZE_CONTEXT:
			return {
				...state,
				...action.payload,
			};
		default: {
			const _exhaustiveCheck: never = action.type;
			return state;
		}
	}
};
